import { render, staticRenderFns } from "./CallSetUpTimeTopMenuButton.vue?vue&type=template&id=7081485d&scoped=true&"
import script from "./CallSetUpTimeTopMenuButton.vue?vue&type=script&lang=js&"
export * from "./CallSetUpTimeTopMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7081485d",
  null
  
)

export default component.exports